<template>
  <tr>
    <td>{{ patientName }}</td>
    <td v-html="dateString"></td>
    <td>{{ heartRate }}</td>
    <td>{{ doctorName }}</td>
    <td>
      <div class="icons">
        <event-icon v-if="training.events" :events-string="training.events" :showToolTip="true"></event-icon>
        <comment-icon :training="training"></comment-icon>
      </div>
      <div class="d-flex align-item-center justify-content-center" v-if="this.showDash">—</div>
    </td>
    <td>
      <status-title :status="training.status" :type="'session'" :connect="connect"></status-title>
      <span id="connection" v-if="isActive" class="connection" :class="spanClass"></span>
    </td>
    <td>{{ $t('src/components/table-rows/trainingstablerow.id', { '1': training.id }) }}</td>
    <td>
      <router-link
        :to="{ name: 'session-view', params: { id: training.id } }"
        class="btn btn-outline-primary"
        >{{ $t('button.open') }}</router-link
      >
    </td>
  </tr>
</template>

<script>
import CommentIcon from '@/components/Training/CommentIcon.vue'
import EventIcon from '@/components/Training/EventIcon.vue'
import StatusTitle from '@/components/StatusTitle.vue'
import { status, DATE_FORMAT, eventTypes } from '@/main.config.js'
import { trainingDate } from '@/mixins/training-date.js'
import { userRights } from '@/mixins/user-rights.js'
import { subscribeMobileEvents } from '@/mixins/subscribe-mobile-events.js'

export default {
  name: 'TrainingsTableRow',
  mixins: [trainingDate, userRights, subscribeMobileEvents],
  components: {
    CommentIcon: CommentIcon,
    StatusTitle: StatusTitle,
    EventIcon: EventIcon
  },
  data: () => ({
    showDash: false,
    now: null,
    timer: null,
    duration: null,
    connect: true,
    currentHR: null,
    diffTimeComputerAndServer: null
  }),
  props: {
    training: {
      type: Object,
      required: true
    }
  },
  mounted() {
    this.now = this.moment().local()
    if (this.$el.getElementsByClassName('icons')[0].children.length === 0) {
      this.showDash = true
    }
    if (this.isActive) {
      this.updateNow()
      this.canSubscribe = true
    }
    let front = this.moment().utc()
    let back = this.moment(this.training.currentDateTime).utc()
    this.diffTimeComputerAndServer = front.diff(back, 'seconds')
  },
  watch: {
    duration() {
      let diff = this.duration - +localStorage.getItem(`lastDataTime${this.training.id}`)
      if (diff >= 40) {
        this.connect = false
      } else {
        this.connect = true
      }
    },
    isActive() {
      if (this.isActive) {
        this.updateNow()
      } else {
        clearInterval(this.timer)
      }
    },
    now() {
      this.duration = this.now.diff(this.trainingStartDate, 'seconds') - this.diffTimeComputerAndServer
    }
  },
  computed: {
    isActive() {
      return this.training.status === status.active
    },
    trainingId() {
      return this.training.id
    },
    patientName() {
      if (this.isNeuroAdmin) {
        return String(this.training.patient.id).padStart(5, '0')
      } else return this.training.patient.surname + ' ' + this.training.patient.name
    },
    dateString() {
      const startMomentDate = this.getTrainingMomentStartDate(this.training)
      const endMomentDate = this.getTrainingMomentEndDate(this.training)

      let date = startMomentDate.format(DATE_FORMAT.ru)

      if (this.training.status !== status.plan) {
        date += '<br/><small>' + startMomentDate.format(DATE_FORMAT.timeHM) + '</small>'
      }

      if (endMomentDate) {
        date += '<small> - ' + endMomentDate.format(DATE_FORMAT.timeHM) + '</small>'
      }

      return date
    },
    doctorName() {
      if (this.isNeuroAdmin) {
        return String(this.training.doctor.id).padStart(5, '0')
      } else return this.training.doctor.surname + ' ' + this.training.doctor.name
    },
    heartRate() {
      if (this.training.status === status.active) {
        return this.currentHR
      }
      let min, max, avr
      if (this.training.status === status.done) {
        min = this.training.rhytmogram_min_hr ? Math.round(this.training.rhytmogram_min_hr) : ''
        max = this.training.rhytmogram_max_hr ? Math.round(this.training.rhytmogram_max_hr) : ''
        avr = this.training.rhytmogram_avr_hr ? Math.round(this.training.rhytmogram_avr_hr) : ''
      } else {
        min = this.training.heart_rate_min ? this.training.heart_rate_min : ''
        max = this.training.heart_rate_max ? this.training.heart_rate_max : ''
      }
      if (min === '' && max === '') {
        return '—'
      } else if (avr && avr !== '') {
        return `${avr} (${min} - ${max})`
      } else return min + ' - ' + max
    },
    spanClass() {
      return this.connect ? 'connection-online' : 'connection-offline'
    },
    trainingStartDate() {
      return this.getTrainingMomentStartDate(this.training)
    }
  },
  methods: {
    updateNow() {
      this.timer = setInterval(() => {
        this.now = this.moment().local()
      }, 1000)
    },
    changeDataByEvent(event) {
      if (+this.training.id !== +event.tr_id) {
        return
      }
      this.lastDataTime = event.type === 'SR' && event.value === 0 ? this.lastDataTime : event.time
      localStorage.setItem(`lastDataTime${this.training.id}`, this.lastDataTime)
      this.eventProcessing(event)
    },
    eventProcessing(event) {
      switch (event.type) {
        case eventTypes.changeHR:
          this.currentHR = event.value
          return
        default:
          return
      }
    }
  }
}
</script>
